import React from 'react'
import classNames from 'classnames'

// Header dùng CHUNG cho mọi khối sidebar trang tổ chức (Thông báo/Hội Nhóm/Kênh tin tức/Khoá học/
// Kỳ thi/Sự kiện/Cửa hàng/Lịch sắp tới...) - trước đây MỖI file tự copy-paste y hệt khối markup này
// (8 chỗ, 7 file), riêng phần chữ tiêu đề "font-bold text-base text-slate-700" gần như TRÙNG với chữ
// tiêu đề của từng item bên dưới (cũng font-bold text-base) - không phân biệt được đâu là header của
// cả khối, đâu là nội dung thật (phản hồi thực tế: "kích thước chữ giống nhau, ko phân biệt dc header
// và nội dung"). Sửa 1 chỗ áp dụng chung toàn bộ: thu nhỏ + viết hoa + làm nhạt màu tiêu đề (kiểu
// "eyebrow label" nhỏ, lùi lại phía sau) thay vì cỡ chữ ngang hàng nội dung, bỏ luôn thanh gạch chân
// trang trí (đỡ rối, icon + label nhỏ đã đủ làm điểm neo thị giác).
export const SiderBlockHeader = ({
                                      icon: Icon,
                                      iconBgClassName = 'bg-blue-50',
                                      iconColorClassName = 'text-blue-500',
                                      title,
                                  }) => (
    <div className="flex items-center gap-3">
        <div className={classNames('p-2 flex flex-center rounded-lg flex-shrink-0', iconBgClassName)}>
            <Icon size={16} className={iconColorClassName}/>
        </div>
        <span className="flex-1 min-w-0 font-bold text-xs text-color-300 uppercase tracking-wider">
            {title}
        </span>
    </div>
)
